import type { JSX } from 'react';

import { ThemeProvider } from '@change/ds-core-ui/next';

import { DesignSystemLegacy } from '@change-corgi/design-system-legacy/core';
import { sunriseTheme } from '@change-corgi/design-system-legacy/theme';

import { DetailsContainer } from '../containers/Details';
import { useIsSunriseEnabled } from '../hooks/isSunriseEnabled';

import { useTrackPageView } from './hooks/useTrackPageView';

export function Layout(): JSX.Element {
	useTrackPageView();

	const {
		data: { isSunriseEnabled },
	} = useIsSunriseEnabled();

	return (
		<ThemeProvider>
			<DesignSystemLegacy theme={isSunriseEnabled ? sunriseTheme : undefined}>
				<DetailsContainer />{' '}
			</DesignSystemLegacy>
		</ThemeProvider>
	);
}
